const AccountData = {
    en: {
        seo: {
            title: 'My Account | BH-Hardware',
            description: 'Manage your BH-Hardware account, view order history, and track shipments.'
        },
        profile: {
            badge: 'Customer',
            shopBtn: 'Shop',
            signOutBtn: 'Sign Out'
        },
        stats: {
            totalOrders: 'Total Orders',
            totalSpent: 'Total Spent',
            lastOrder: 'Last Order'
        },
        orders: {
            title: 'Order History',
            orderId: 'Order ID',
            quantity: 'Qty',
            loading: 'Loading your orders...',
            empty: 'No orders yet',
            startShopping: 'Start Shopping'
        }
    },
    he: {
        seo: {
            title: 'החשבון שלי | BH-Hardware',
            description: 'נהל את חשבון BH-Hardware שלך, צפה בהיסטוריית ההזמנות ועקוב אחר משלוחים.'
        },
        profile: {
            badge: 'לקוח',
            shopBtn: 'חנות',
            signOutBtn: 'התנתק'
        },
        stats: {
            totalOrders: 'סה״כ הזמנות',
            totalSpent: 'סה״כ שולם',
            lastOrder: 'הזמנה אחרונה'
        },
        orders: {
            title: 'היסטוריית הזמנות',
            orderId: 'מזהה הזמנה',
            quantity: 'כמות',
            loading: 'טוען את ההזמנות שלך...',
            empty: 'אין הזמנות עדיין',
            startShopping: 'התחל לקנות'
        }
    }
};

export function getAccountData(language) {
    return AccountData[language] || AccountData.en;
}

export default AccountData;
